import AuthService from "./api/AuthService";

export const createIntegrationKeyLTI = async (payload, userToken) => {
    try {
        const response = await AuthService.post('/lti-consumers', payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        throw new Error("Ocorreu um erro ao criar chaves de acesso, tente novamente!")
    }
};

export const getIntegrationKeysLTI = async (payload) => {
    try {
        let url = '/lti-consumers?';
        payload?.search && (url += `search=${payload.search}&`)
        payload?.companyId && (url += `company_id=${payload.companyId}&`)

        const response = await AuthService.get(url);
        return response.data;
    } catch (error) {
        throw new Error("Ocorreu um erro ao requisitar integrações! Tente novamente")
    }
};

export const deleteIntegrationKeyLTI = async (payload) => {
    try {
        const response = await AuthService.delete(`/lti-consumers/${payload}`);
        return response.data;
    } catch (error) {
        throw new Error("Ocorreu um erro ao deletar chave de acesso! Tente novamente");
    }
};

export const getIntegrationToolsLTI = async (payload) => {
    try {
        let url = '/lti-tools?'
        payload?.search && (url += `search=${payload.search}&`)

        const response = await AuthService.get(url)
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao requisitar Ferramentas Externas! Tente novamente")
    }
}

export const createIntegrationToolLTI = async (payload) => {
    try {
        const response = await AuthService.post('/lti-tools', payload)
        return response.data
    } catch (error) {
        const errorMessage = error?.response?.data?.message || "Ocorreu um erro ao criar Ferramenta Externa! Tente novamente"
        throw new Error(errorMessage)
    }
}

export const updateIntegrationToolLTI = async (payload) => {
    try {
        const response = await AuthService.put(`/lti-tools/${payload.id}`, payload)
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao atualizar Ferramenta Externa! Tente novamente")
    }
}

export const deleteIntegrationToolLTI = async (payload) => {
    try {
        const response = await AuthService.delete(`/lti-tools/${payload}`)
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao deletar Ferramenta Externa! Tente novamente")
    }
}

export default {
    getIntegrationToolsLTI,
    createIntegrationToolLTI,
    updateIntegrationToolLTI,
    deleteIntegrationToolLTI,
    createIntegrationKeyLTI,
    getIntegrationKeysLTI,
    deleteIntegrationKeyLTI
}